import * as React from 'react';
import { shallow, mount } from 'enzyme';
import RevokeHandshake, { Props } from './RevokeHandshake';
import Button from 'lj_shared/button/button';

let props: Props;
let wrapped = null;

const createTestProps = () => {
  return {
    cancelReasons: [
      'I got a more interesting proposal.',
      "I got second feelings and I'm backing down",
    ],
    handshake: jest.fn(),
    handshake_company: {
      name: 'test company',
      id: 10032,
      logo: 'this is a logo URL',
    },
    handshake_job_ad: { title: 'my job', id: 177013 },
  };
};

describe('Revoke Handshake component', () => {
  beforeAll(() => {
    props = createTestProps();
    wrapped = shallow(<RevokeHandshake {...props} />);
  });

  it('shallow renders without crashing', () => {
    expect(wrapped.exists()).toBe(true);
  });

  it('contains 1 Button', () => {
    expect(wrapped.find(Button).length).toEqual(1);
  });
});
